import { createFileRoute } from '@tanstack/react-router';

import DayToDayForm from 'src/components/DayToDayForm';
import PageHeader from 'src/components/PageHeader';
import { InnerMaxWidthContainer } from 'src/layouts/InnerMaxWidthContainer';

export const Route = createFileRoute('/(app)/care/day-to-day/routines')({
    component: AdlsEditRoutinesComponent,
});

function AdlsEditRoutinesComponent() {
    return (
        <InnerMaxWidthContainer>
            <PageHeader />
            <DayToDayForm
                dayToDayName="ROUTINES_PREFERENCES"
                title="Routines & Interests"
                description="Help caregivers get to know them better. Share their daily routines, habits, and personal preferences so care feels familiar and comfortable."
                placeholder="e.g., likes to read in the morning, enjoys classical music, prefers quiet afternoons, loves gardening"
                nextRoute="/care"
                buttonText="Save & Complete"
            />
        </InnerMaxWidthContainer>
    );
}
